import ReactHtmlParser, {
  attributesToProps,
  domToReact,
} from "html-react-parser";
import React from "react";
import { concatClassnames, decodeHtml } from "./util";

export const parseJobHtml = (html: string) => {
  return ReactHtmlParser(decodeHtml(html), htmlParserOptions);
};
const htmlParserOptions = {
  replace: (domNode: any) => {
    const name: string = domNode.name ?? "";

    if (domNode.attribs && name.match(/h\d/)) {
      const props = attributesToProps(domNode.attribs);
      return (
        <div
          {...props}
          className={concatClassnames([`cvp-${name}`, props.className])}
        >
          {domToReact(domNode.children, htmlParserOptions)}
        </div>
      );
    }
  },
};
